import httpClient from "./httpClient"; // Adjust path if needed

const AnnouncementService = {
  async findAll(page, pageSize) {
    return await httpClient.get("/announcement", {
      params: { page, pageSize }
    });
  },

  async findById(announcementId) {
    return await httpClient.get(`/announcement/${announcementId}`);
  },

  async create(entity) {
    return await httpClient.post("/announcement", entity);
  },

  async update(entity) {
    return await httpClient.put(`/announcement/${entity.id}`, entity);
  },

  async pushMembers(announcementId) {
    return await httpClient.get(`/announcement/push-members/${announcementId}`);
  },

  async activate(announcementId, notes) {
    return await httpClient.post(`/announcement/${announcementId}/activate`, { notes });
  },

  async close(announcementId, closeNotes) {
    return await httpClient.post(`/announcement/${announcementId}/close`, { closeNotes });
  },

  async reject(announcementId, reason) {
    return await httpClient.post(`/announcement/${announcementId}/reject`, { reason });
  },

  async getHistory(announcementId) {
    return await httpClient.get(`/announcement/${announcementId}/history`);
  }
};

export default AnnouncementService;
